
<template>
	<div ref="listWrap">
		<wrapper-list 
		 @add="paasAddPage"
        @calculate="paasCalculate"      
		ref="wrapperList" >
      	<Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
		<row class="list-query-row">
		<FormItem label="是否显示" class="list-query-item">
			  <Enum :enumJsonKey="'crmdict-isShow'"  v-model="queryParam.query_EQ_isShow"
		        @on-change="queryTableDatas" >
		    </Enum>	
		</FormItem>
		<FormItem label="会员名称" class="list-query-item">
			<Input  v-model="queryParam.query_EQ_name" placeholder=""
				@on-change="queryTableDatas" clearable />	
		</FormItem>
		</row>
      	</Form>
      	<Table slot="table" stripe border :height="tableHeight"
             :data="tableData"
             :columns="tableColumns"
             @on-selection-change="selectTableDataChange"
             @on-sort-change="sortTableData"
             :no-data-text="noDataText">
        </Table>
        </wrapper-list>
   </div>
</template>
<script>
	  import wrapperList from "@components/paas/wrapper-list";
    import metaList from "@assets/js/list/meta-list.js";
    import EnumShow from "@components/paas/enum-show";  //如果有枚举，需要引入
    import Enum from '@components/paas/query-enum' //枚举查询
    import CellBar from '@components/paas/cell-bar' //列表内操作
    export default {
      name: "list",
      mixins: [ metaList ],
      components: { wrapperList,EnumShow,Enum,CellBar},
      data() {
      	return {
      		serviceUrl:"/eb/user/level",  //每个页面访问后台服务器的路径
      		currentIdFiledName: 'id',
      		queryParam:{
   				iDisplayLength:null,
				query_EQ_isShow:'',
				query_EQ_name:'',
	        },
	        defaultLabelWidth:200,
	         tableColumns:[
	        	{
	              type: 'index',  //type: 'index'，可以排序
	              width: 40,
	              align: 'center',
	            },
	        	{
	        		title: '会员图标',
	        		key: 'levelIcon',
              render:(h,params)=>{
                if(params.row.levelIcon){
                  return h('img',{
                    attrs: {
                      src: params.row.levelIcon,
                    },
                    style:{
                      width:"45px",
                      height:"45px"
                    }
                  })
                }
              }
	        	},
	        	{
	        		title: '会员名称',
	        		key: 'name',
	        	},
	        	{
	        		title: '会员等级',
	        		key: 'gradeLevel',
	        	},
             {
               title: '最低购买金额',
               key: 'money',
             },
	        	{
	        		title: '享受折扣',
	        		key: 'discount',
	        	},
	        	{
	        		title: '有效时间',
	        		key: 'validDate',
	        	},
	        	{
	        		title: '是否为永久会员',
	        		key: 'isForever',
	        		render:(h,params)=>{
		                return h(EnumShow,{
		                  props:{
		                    enumGroupCode:'crmdict',
		                    enumCode:'yesOrNo',
		                    value:params.row.isForever
		                  }
		                })
		            }
	        	},
	        	{
	        		title: '是否购买',
	        		key: 'isPay',
	        		render:(h,params)=>{
		                return h(EnumShow,{
		                  props:{
		                    enumGroupCode:'crmdict',
		                    enumCode:'yesOrNo',
		                    value:params.row.isPay
		                  }
		                })
		            }
	        	},
	        	{
	        		title: '是否显示',
	        		key: 'isShow',
	        		render:(h,params)=>{
		                return h(EnumShow,{
		                  props:{
		                    enumGroupCode:'crmdict',
		                    enumCode:'isShow',
		                    value:params.row.isShow
		                  }
		                })
		            }
	        	},
	        	{
	        		title: '说明',
	        		key: 'explainDesc',
	        	},
	        	{	
	        		title: '操作',
              width:'140',
	        		render: (h, params) => {
		                return h(CellBar,
		                    {
			                  props:{
			                    show:'textIcon'  //操作也显示标准按钮的样式（text、icon、textIcon）
			                  },
			                  //自定义事件监听器“on”,不支持如v-on:keyup.enter的修饰符，需要手动匹配keyCode
			                    on: {
			                      // 子组件$emit传递函数,必须是箭头函数写法
			                      'edit': ()=> {
			                        this.$nextTick(()=>{
			                          this.paasEditOper(params.row[this.currentIdFiledName]);
			                        })
			                      },
			                      'delete':()=>{
			                        this.$nextTick(()=>{
			                          this.paasDeleteOper(params.row[this.currentIdFiledName]);
			                        })
			                      },
			                    }
			                }
			            )
		            }
		         }
	        ],
      	}
      },
      mounted(){
      },
      methods:{
      }
    } 
</script>
